import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { PreOrderListModel } from '../models/models'

export class DeletePreOrderProductApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/preOrder/deleteProductFromPreOrder',
      requesterInfo,
    })
  }

  public async deleteProduct(request: number): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
